<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
	[tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="tipoConsulta!='BIN_FEDERAL_RF'">
	<ng-container *ngIf="consulta">

		<ng-container *ngFor="let v of consulta?.lista; let i = index;">
			<h2 class="subtitle subtitle-danger ">{{i+1}}º OCORRÊNCIA</h2>
			<ul class="card-list-striped">
				<li><span class="text-secondary">Categoria ocorrência </span>
					<span>{{v?.categoriaOcorrencia|| "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Órgão de segurança </span>
					<span>{{v?.orgaoSeguranca || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Número ocorrência </span>
					<span>{{v?.numeroOcorrencia || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Data ocorrência </span>
					<span>{{v?.dataOcorrencia || "NÃO INFORMADO"}}</span>
				</li>
				<li><span class="text-secondary">Município emplacamento </span>
					<span>{{consulta?.municipio || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Marca/Modelo </span>
					<span>{{consulta?.marcaModelo || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Ano modelo </span>
					<span>{{consulta?.anoModelo|| "NÃO INFORMADO"}}</span>
				</li>
				<li><span class="text-secondary">Ano </span> <span>{{v?.ano || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Boletim </span> <span>{{v?.boletim || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Tipo declaração </span>
					<span>{{v?.tipoDeclaracao || "NÃO INFORMADO"}}</span>
				</li>
				<li><span class="text-secondary">Alarme </span> <span>{{v?.alarme || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">UF emplacamento </span>
					<span>{{consulta?.uf || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Cor </span> <span>{{consulta?.cor || "NÃO INFORMADO"}}</span></li>
				<li><span class="text-secondary">Ano fabricação </span>
					<span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span></li>
			</ul>
		</ng-container>
	</ng-container>
	</ng-container>

</app-card-consulta>
